var angular = require('angular')

angular.module('AemBranchesAppointments')
  .component('appointmentError', {
    template: require('./appointment-error.component.tpl.html'),
    controller: AppointmentErrorCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

AppointmentErrorCtrl.$inject = ['appLoader']

function AppointmentErrorCtrl (appLoader) {
  var vm = this

  vm.$onInit = function () {
    appLoader.hide()
  }
}
